import React from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";
import EventNoteOutlinedIcon from "@material-ui/icons/EventNoteOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import HowToRegOutlinedIcon from "@material-ui/icons/HowToRegOutlined";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import TrendingUpOutlinedIcon from "@material-ui/icons/TrendingUpOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import SwyvelAI from "../SwyvelAI";
import { NAV_BARS, USER_ROLES } from "../../utils/constants";
import { mainNavItems, useNavState, SIDE_NAV_WIDTH } from "../../utils/mainNav";

// The menu down the left side, for an owner or teacher who chose it from
// their account menu (Stefan, call 10, Oct 28 2026: "most monitors are...
// longer than taller"). The page beside it gets the whole width, and the
// top bar and the row of pills give their height back to the page.
//
// The sections are the top menu's (utils/mainNav). The section the page is
// in shows its tabs under it, the same tabs the page would draw across its
// top, so the page leaves that row out. What the top bar's right end held
// moves here too: the staff inbox and notifications beside the name, Swyvel
// AI and the account at the bottom.
//
// No coloured stripe marks where you are: the section is the black pill the
// top menu already uses, full width.

const ICONS = {
  home: HomeOutlinedIcon,
  my_studio: StorefrontOutlinedIcon,
  lessons: EventNoteOutlinedIcon,
  classes: PeopleAltOutlinedIcon,
  attendance: HowToRegOutlinedIcon,
  contacts: ContactsOutlinedIcon,
  money: AccountBalanceWalletOutlinedIcon,
  grow: TrendingUpOutlinedIcon,
  campaigns: EmailOutlinedIcon,
  studio: StorefrontOutlinedIcon,
  calendar: CalendarTodayOutlinedIcon,
};

const CSS = `
.swyvel-side {
  position: fixed; top: 0; left: 0; bottom: 0; width: ${SIDE_NAV_WIDTH}px; z-index: 1150;
  box-sizing: border-box; display: flex; flex-direction: column;
  padding: 16px 12px 12px; background: #ffffff; border-right: 1px solid #E1E5EA;
  font-family: 'Nunito', 'Varela Round', sans-serif;
}
.swyvel-side--enter { animation: swyvelSideIn .32s cubic-bezier(.22,.9,.36,1); }
@keyframes swyvelSideIn { from { transform: translateX(-24px); opacity: 0; } to { transform: none; opacity: 1; } }
.swyvel-side a, .swyvel-side button { -webkit-tap-highlight-color: transparent; }
.swyvel-side a:focus-visible, .swyvel-side button:focus-visible { outline: 2px solid #007BFF; outline-offset: 1px; }

.swyvel-side__top { display: flex; align-items: center; justify-content: space-between; gap: 4px; margin-bottom: 12px; padding-left: 12px; }
.swyvel-side__brand {
  font-size: 27px; font-weight: 400; line-height: 40px; color: #000000;
  text-transform: uppercase; text-decoration: none;
}
.swyvel-side__icons { display: flex; gap: 2px; }
.swyvel-side__icon {
  position: relative; width: 36px; height: 36px; padding: 0; border: 0; border-radius: 10px;
  display: inline-flex; align-items: center; justify-content: center;
  background: transparent; color: #4F4F4F; cursor: pointer;
  transition: background-color .15s ease, color .15s ease, transform .15s ease;
}
.swyvel-side__icon svg { font-size: 21px; }
.swyvel-side__icon:hover { background: #F2F4F7; color: #1a1a1a; }
.swyvel-side__icon:active { transform: scale(.92); }
.swyvel-side__icon .swyvel-side__badge { position: absolute; top: 1px; right: 0; min-width: 18px; height: 18px; padding: 0 5px; border: 2px solid #ffffff; }

.swyvel-side__cta {
  display: flex; align-items: center; justify-content: center; gap: 8px;
  height: 44px; margin: 0 0 12px; border-radius: 140px;
  background: #007BFF; color: #ffffff; font-size: 15px; font-weight: 700; text-decoration: none;
  box-shadow: 0 1px 2px rgba(0, 86, 179, .2);
  transition: background-color .15s ease, box-shadow .2s ease, transform .18s cubic-bezier(.2,.8,.2,1);
}
.swyvel-side__cta svg { font-size: 19px; }
.swyvel-side__cta:hover { background: #0069DB; box-shadow: 0 6px 16px rgba(0, 123, 255, .3); transform: translateY(-1px); }
.swyvel-side__cta:active { transform: scale(.98); box-shadow: 0 1px 2px rgba(0, 86, 179, .2); }
.swyvel-side__cta.is-active { background: #0062CC; }

.swyvel-side__nav { flex: 1; min-height: 0; overflow-y: auto; margin: 0 -6px; padding: 0 6px; scrollbar-width: thin; }
.swyvel-side__list, .swyvel-side__sub { list-style: none; margin: 0; padding: 0; }
.swyvel-side__list { display: flex; flex-direction: column; gap: 2px; }

.swyvel-side__item {
  display: flex; align-items: center; gap: 12px; width: 100%; height: 40px; padding: 0 12px;
  box-sizing: border-box; border: 0; border-radius: 12px; background: transparent; cursor: pointer;
  color: #4F4F4F; font: inherit; font-size: 15px; font-weight: 600; text-align: left; text-decoration: none;
  white-space: nowrap; transition: background-color .15s ease, color .15s ease, transform .15s ease;
}
.swyvel-side__item svg { flex: 0 0 auto; font-size: 21px; color: #666666; transition: color .15s ease, transform .3s cubic-bezier(.2,.8,.2,1); }
.swyvel-side__item:hover { background: #F2F4F7; color: #1a1a1a; }
.swyvel-side__item:hover svg { color: #1a1a1a; transform: scale(1.1); }
.swyvel-side__item:active { transform: scale(.98); }
.swyvel-side__item.is-active { background: #1a1a1a; color: #ffffff; }
.swyvel-side__item.is-active svg { color: #ffffff; transform: none; }

.swyvel-side__sub { display: flex; flex-direction: column; gap: 1px; margin: 3px 0 6px; padding-left: 33px; }
.swyvel-side__subitem {
  display: block; padding: 6px 12px; border-radius: 10px;
  color: #666666; font-size: 14px; font-weight: 600; text-decoration: none;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  transition: background-color .15s ease, color .15s ease;
}
.swyvel-side__subitem:hover { background: #F2F4F7; color: #1a1a1a; }
.swyvel-side__subitem.is-active { background: #EEF0F3; color: #1a1a1a; font-weight: 700; }

.swyvel-side__foot { display: flex; flex-direction: column; gap: 2px; margin-top: 10px; padding-top: 10px; border-top: 1px solid #EEF0F3; }
.swyvel-side__ai { margin-bottom: 4px; }
.swyvel-side__badge {
  min-width: 20px; height: 20px; padding: 0 6px; box-sizing: border-box; border-radius: 10px;
  display: inline-flex; align-items: center; justify-content: center;
  background: #E5484D; color: #ffffff; font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums;
}
.swyvel-side__me { height: 52px; padding: 0 8px 0 6px; }
.swyvel-side__me.is-open { background: #F2F4F7; }
.swyvel-side__avatar {
  flex: 0 0 auto; width: 34px; height: 34px; border-radius: 50%; overflow: hidden;
  display: inline-flex; align-items: center; justify-content: center;
  background: #EEF0F3; color: #1a1a1a; font-size: 14px; font-weight: 700;
}
.swyvel-side__avatar img { width: 100%; height: 100%; object-fit: cover; }
.swyvel-side__who { min-width: 0; display: flex; flex-direction: column; line-height: 1.2; }
.swyvel-side__name { color: #1a1a1a; font-size: 15px; font-weight: 700; overflow: hidden; text-overflow: ellipsis; }
.swyvel-side__role { color: #666666; font-size: 12.5px; font-weight: 600; }
.swyvel-side__me .swyvel-side__chev { margin-left: auto; font-size: 18px; }

@media (prefers-reduced-motion: reduce) {
  .swyvel-side--enter { animation: none; }
  .swyvel-side__item, .swyvel-side__item svg, .swyvel-side__cta, .swyvel-side__icon { transition: none; }
  .swyvel-side__item:hover svg, .swyvel-side__cta:hover, .swyvel-side__item:active, .swyvel-side__cta:active, .swyvel-side__icon:active { transform: none; }
}
`;

const SideNav = ({
  entering = false,
  avatarUrl,
  staffUnreadCount = 0,
  notificationCount = 0,
  accountOpen = false,
  onOpenAccount,
  onOpenNotifications,
}) => {
  const user = window.current_user || {};
  const owner = user.role === USER_ROLES.STUDIO;
  const staff = owner || user.role === USER_ROLES.INSTRUCTOR;
  const { active, sub } = useNavState();
  const items = mainNavItems(user);
  const tabs = Array.isArray(sub) && sub.length > 1 ? sub : null;
  const openKey = (items.find((item) => item.nav === active) || {}).key;

  // The page hides its own row of tabs only when they are drawn here, so a
  // page in no section (or one whose section is not in this person's menu)
  // keeps them.
  const tabsHere = !!(tabs && openKey);
  React.useEffect(() => {
    document.body.classList.toggle("side-has-sub", tabsHere);
    return () => document.body.classList.remove("side-has-sub");
  }, [tabsHere]);

  // The page makes room for the menu once it is here (application.scss);
  // pages that measure the window for themselves measure again.
  React.useEffect(() => {
    window.dispatchEvent(new Event("resize"));
    return () => window.dispatchEvent(new Event("resize"));
  }, []);

  const initial = (user.first_name || "?").trim().charAt(0).toUpperCase();

  return (
    <aside className={`swyvel-side${entering ? " swyvel-side--enter" : ""}`} data-testid="side-nav">
      <style>{CSS}</style>
      <div className="swyvel-side__top">
        <a href="/" className="swyvel-side__brand">Swyvel</a>
        {/* What the top bar's right end held, beside the name, so the list
            below keeps its room. */}
        <div className="swyvel-side__icons">
          {staff && (
            <a href="/inbox" className="swyvel-side__icon" aria-label="Staff inbox" title="Staff inbox">
              <ForumOutlinedIcon aria-hidden="true" />
              {staffUnreadCount > 0 && <span className="swyvel-side__badge">{staffUnreadCount}</span>}
            </a>
          )}
          <button type="button" className="swyvel-side__icon" onClick={onOpenNotifications} aria-label="Notifications" title="Notifications">
            <NotificationsNoneOutlinedIcon aria-hidden="true" />
            {notificationCount > 0 && <span className="swyvel-side__badge">{notificationCount}</span>}
          </button>
        </div>
      </div>

      {owner && (
        <a
          href="/lessons/view_calendar"
          className={`swyvel-side__cta${active === NAV_BARS.CALENDAR ? " is-active" : ""}`}
          aria-current={active === NAV_BARS.CALENDAR ? "page" : undefined}
        >
          <CalendarTodayOutlinedIcon aria-hidden="true" />
          My calendar
        </a>
      )}

      <nav className="swyvel-side__nav" aria-label="Main">
        <ul className="swyvel-side__list">
          {items.map((item) => {
            const Icon = ICONS[item.key] || HomeOutlinedIcon;
            const on = item.key === openKey;
            return (
              <li key={item.key}>
                <a
                  href={item.href}
                  className={`swyvel-side__item${on ? " is-active" : ""}`}
                  aria-current={on ? (tabs ? "true" : "page") : undefined}
                >
                  <Icon aria-hidden="true" />
                  {item.label}
                </a>
                {on && tabs && (
                  <ul className="swyvel-side__sub" aria-label={item.label}>
                    {tabs.map((tab) => (
                      <li key={tab.key}>
                        <a
                          href={tab.href}
                          className={`swyvel-side__subitem${tab.active ? " is-active" : ""}`}
                          aria-current={tab.active ? "page" : undefined}
                          title={tab.label}
                        >
                          {tab.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="swyvel-side__foot">
        {owner && (
          <div className="swyvel-side__ai">
            <SwyvelAI block />
          </div>
        )}
        <button
          type="button"
          className={`swyvel-side__item swyvel-side__me${accountOpen ? " is-open" : ""}`}
          onClick={onOpenAccount}
          aria-label="Account menu"
          aria-expanded={accountOpen}
        >
          <span className="swyvel-side__avatar" aria-hidden="true">
            {avatarUrl ? <img src={avatarUrl} alt="" /> : initial}
          </span>
          <span className="swyvel-side__who">
            <span className="swyvel-side__name">{user.first_name}</span>
            <span className="swyvel-side__role">{owner ? "Owner" : "Teacher"}</span>
          </span>
          <UnfoldMoreIcon className="swyvel-side__chev" aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
};

export default SideNav;
